import React, { useEffect, useRef, useState } from 'react';
// Utils
import { validArray } from 'utils';
// Elements
import { CheckItem } from 'elements/ListItems';
import SelectToggle from './SelectToggle';
// Style
import styles from './style/select.module.css';

interface SelectMultiProps {
  disabled?: boolean,
  handleOnChange: Function,
  items: string[],
  label: string,
  name: string,
  value: string,
}

function SelectMulti({
  disabled,
  handleOnChange,
  items,
  label,
  name,
  value,
}:SelectMultiProps) {
  const [open, setOpen] = useState(false);
  const select = useRef<HTMLDivElement>(null);

  function handleClickOutside(e:MouseEvent) {
    if (e.target instanceof Element) {
      if (select && select.current && select.current.contains(e.target)) {
        return;
      }
    }
    setOpen(false);
  }

  function toggleOpen() {
    if (!disabled) {
      setOpen(!open);
    }
  }

  useEffect(() => {
    if (open) {
      document.addEventListener('mousedown', handleClickOutside);
    } else {
      document.removeEventListener('mousedown', handleClickOutside);
    }
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [open]);

  function renderItems(item:string) {
    return (
      <CheckItem
        borderInset={1}
        checked={Boolean(validArray(value) && value.split(', ').includes(item))}
        handler={(e:React.ChangeEvent) => handleOnChange(e)}
        key={item}
        label={item}
        name={name}
        value={item}
      />
    )
  }

  return (
    <div
      className={`
        ${styles.select} 
        ${open ? styles.select_open : ''} 
        ${value ? styles.select_hasValue : ''} 
        ${disabled ? styles.select_disabled : ''}
      `}
      ref={select}
    >
      <SelectToggle
        active={open}
        disabled={disabled}
        handler={toggleOpen}
        label={label}
        value={value || ''}
      />
      <div className={styles.select__options}>
        {validArray(items) && items.map(renderItems)}
      </div>
    </div>
  );
}

SelectMulti.defaultProps = {
  disabled: false,
}

export default SelectMulti;
